import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntercomModule } from '@supy-io/ngx-intercom';

@NgModule({
  imports: [
    CommonModule,
    IntercomModule.forRoot({
      appId: '',
    }),
  ],
})
export class MicroCoreChatModule {}
